
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.4 8.235c-.108.17-.201.346-.276.542l-.755 1.874C31.502 7.946 27.795 6.32 23.742 6.32c-9.043 0-16.395 8.1-16.395 18.063 0 1.693.207 3.33.61 4.879L6.195 31.6A22.17 22.17 0 015 24.383c0-11.388 8.406-20.65 18.742-20.65 4.4 0 8.453 1.689 11.658 4.502zM43.002 24.68c0 10.802-8.898 19.587-19.839 19.587a19.89 19.89 0 01-15.628-7.546l.179-.215c0-.01.01-.01.01-.01L9.23 34.87a17.367 17.367 0 0016.422 6.768l1.26-.226c7.766-1.694 13.604-8.55 13.604-16.732 0-2.924-.749-5.666-2.058-8.08l1.23-2.733a19.263 19.263 0 013.313 10.813z","fill":"#fff"}}),_c('path',{attrs:{"d":"M25.463 41.733L15.278 25.12 7.112 36.077c-.42.563-1.174.637-1.68.17-.507-.468-.578-1.307-.158-1.87l10.19-13.672 9.55 15.584 10.634-26.7c.268-.67.974-.972 1.576-.675.602.298.874 1.084.607 1.753L25.462 41.733z","fill":"#fff"}})])
          )
        }
      }
    